export const SUPPORTED_FONTS_LIST = [
  "Georgia",
  "PT Sans",
  "Montserrat",
  "Lexend",
  "Poppins",
  // "Arial",
  // "Tahoma",
  // "Verdana",
  // "Helvetica",
  // "Times New Roman",
  // "Trebuchet MS",
  // "Roboto",
  // "Open Sans",
  // "Montserrat",
  // "Poppins",
  // "Lato",
  // "Noto Sans JP",
  // "Inter",
  // // "Material Icons",
  // "Roboto Condensed",
  // "Oswald",
  // "Roboto Mono",
  // "Noto Sans",
  // "Raleway",
  // "Ubuntu",
  // "Rubik",
  // "Nunito Sans",
  // "Merriweather",
  // "Playfair Display",
  // "Roboto Slab",
  // "Noto Sans KR",
  // "Nunito",
  // "Work Sans",
  // "Mulish",
  // "Kanit",
  // "Noto Sans TC",
  // "Barlow",
  // "Fira Sans",
  // "Lora",
  // "DM Sans",
  // "Quicksand",
  // "Titillium Web",
  // "Nanum Gothic",
  // "IBM Plex Sans",
  // "Heebo",
  // "Manrope",
  // "PT Serif",
  // "Inconsolata",
  // // "Material Symbols Outlined",
  // // "Material Icons Outlined",
  // "Libre Franklin",
  // "Mukta",
  // "Hind Siliguri",
  // "Karla",
  // "Noto Serif",
  // "Bebas Neue",
  // "Arimo",
  // "Dosis",
  // "Cabin",
  // "Bitter",
  // "Barlow Condensed",
  // "Noto Color Emoji",
  // "Abel",
  // "Archivo",
  // "Source Code Pro",
  // "Jost",
  // "Josefin Sans",
  // "Hind Madurai",
  // "Dancing Script",
  // "Libre Baskerville",
  // "Anton",
  // "Material Symbols Rounded",
  // "EB Garamond",
  // "Cairo",
  // "Oxygen",
  // "Noto Sans SC",
  // "PT Sans Narrow",
  // "Hind",
  // "Noto Serif JP",
  // "Outfit",
  // // "Material Icons Round",
  // "Teko",
  // "Noto Sans HK",
  // "Pacifico",
  // "Crimson Text",
  // "Nanum Gothic Coding",
  // "Public Sans",
  // "Comfortaa",
  // "Lobster",
  // "Exo 2",
  // "Space Grotesk",
  // "Assistant",
  // "Prompt",
  // "Fjalla One",
  // "Signika Negative",
  // "Varela Round",
  // "Figtree",
  // "M PLUS Rounded 1c",
  // "Overpass",
  // "Chakra Petch",
  // "Red Hat Display",
  // "Arvo",
  // "Rajdhani",
  // // "Material Icons Sharp",
  // "Maven Pro",
  // "Source Sans 3",
  // "Caveat",
  // "IBM Plex Mono",
  // "Play",
  // "Slabo 27px",
  // "Zilla Slab",
  // "Cormorant Garamond",
  // "Fira Sans Condensed",
  // "Noto Sans Arabic",
  // "Shadows Into Light",
  // "Lexend",
  // "Asap",
  // "Barlow Semi Condensed",
  // "Plus Jakarta Sans",
  // // "Material Icons Two Tone",
  // "Abril Fatface",
  // "Satisfy",
  // "Archivo Black",
  // "Lilita One",
  // "Permanent Marker",
  // "DM Serif Display",
  // "Tajawal",
  // "Indie Flower",
  // "IBM Plex Serif",
  // "Nanum Myeongjo",
  // "Merriweather Sans",
  // "Domine",
  // "Questrial",
  // "M PLUS 1p",
  // "Rowdies",
  // "Sora",
  // "Yanone Kaffeesatz",
  // "Signika",
  // "Catamaran",
  // "Crimson Pro",
  // "IBM Plex Sans Arabic",
  // "Urbanist",
  // "Source Serif 4",
  // "Roboto Flex",
  // "Almarai",
  // "Sarabun",
  // "Noticia Text",
  // "Archivo Narrow",
  // "Noto Kufi Arabic",
  // "Didact Gothic",
  // "Acme",
  // "Orbitron",
  // "Vollkorn",
  // "Cinzel",
  // "Frank Ruhl Libre",
  // "Montserrat Alternates",
  // "Exo",
  // "Russo One",
  // "Bree Serif",
  // "Alegreya Sans",
  // "Amatic SC",
  // "ABeeZee",
  // "Marcellus",
  // "Alegreya",
  // "Kalam",
  // "Be Vietnam Pro",
  // "Tinos",
  // "Spectral",
  // "Zeyada",
  // "Alfa Slab One",
  // "Saira Condensed",
  // "Mate",
  // "Philosopher",
  // "Great Vibes",
  // "Encode Sans",
  // "Chivo",
  // "Cormorant",
  // "Changa",
  // "Lexend Deca",
  // "Libre Caslon Text",
  // "Khand",
  // "Concert One",
  // "Noto Serif KR",
  // "Amiri",
  // "Prata",
  // "Noto Sans Thai",
  // "Martel",
  // "Courgette",
  // "Old Standard TT",
  // "Passion One",
  // "Patua One",
  // "Righteous",
  // "Merienda",
  // "Lobster Two",
  // "Cardo",
  // "Noto Sans Display",
  // "PT Sans Caption",
  // "Asap Condensed",
  // "Ubuntu Condensed",
  // "IBM Plex Sans Condensed",
  // "Cantarell",
  // "League Spartan",
  // "Josefin Slab",
  // "Sawarabi Mincho",
  // "Space Mono",
  // "Neuton",
  // "Francois One",
  // "Titan One",
  // "Sacramento",
  // "Noto Serif TC",
  // "Alice",
  // "Yantramanav",
  // "Luckiest Guy",
  // "Oleo Script",
  // "Quattrocento Sans",
  // "Crete Round",
  // "Arsenal",
  // "Paytone One",
  // "Mate SC",
  // "Kaushan Script",
  // "Noto Sans Bengali",
  // "Gloria Hallelujah",
  // "Gothic A1",
  // "Ubuntu Mono",
  // "Bodoni Moda",
  // "Saira",
  // "Unbounded",
  // "Readex Pro",
  // "Alata",
  // "Pathway Gothic One",
  // "Rubik Mono One",
  // "Yellowtail",
  // "DM Serif Text",
  // "El Messiri",
  // "Quattrocento",
  // "Gruppo",
  // "Black Ops One",
  // "Noto Sans Mono",
  // "Architects Daughter",
  // "Sawarabi Gothic",
  // "Albert Sans",
  // "Roboto Serif",
  // "Zen Kaku Gothic New",
  // "Eczar",
  // "Inter Tight",
  // "Noto Naskh Arabic",
  // "Yeseva One",
  // "Libre Barcode 39",
  // "Sanchez",
  // "Encode Sans Condensed",
  // "Rokkitt",
  // "Antic Slab",
  // "Fraunces",
  // "Cookie",
  // "Commissioner",
  // "Macondo",
  // "Cuprum",
  // "Poiret One",
  // "Fira Sans Extra Condensed",
  // "Special Elite",
  // "Bungee",
  // "Sen",
  // "Unna",
  // "Gelasio",
  // "Literata",
  // "Silkscreen",
  // "Alegreya Sans SC",
  // "Patrick Hand",
  // "Allura",
  // "Tangerine",
  // "Bangers",
  // "Creepster",
  // "Advent Pro",
  // "Aleo",
  // "News Cycle",
  // "Taviraj",
  // "Staatliches",
  // "Mitr",
  // "DM Mono",
  // "Tenor Sans",
  // "Playfair Display SC",
  // "Antonio",
  // "Comic Neue",
  // "Rubik Bubbles",
  // "Kumbh Sans",
  // "Red Hat Text",
  // "JetBrains Mono",
  // "Carter One",
  // "Fugaz One",
  // "Courier Prime",
  // "Kosugi Maru",
  // "Handlee",
  // "STIX Two Text",
  // "Secular One",
  // "PT Mono",
  // "Mukta Malar",
  // "Amaranth",
  // "Abhaya Libre",
  // "Parisienne",
  // "Adamina",
  // "Yatra One",
  // "Vidaloka",
  // "Viga",
  // "Syne",
  // "Noto Sans Devanagari",
  // "Pangolin",
  // "Gudea",
  // "Pridi",
  // "Homemade Apple",
  // "Faustina",
  // "Baskervville",
  // "Blinker",
  // "Cousine",
  // "Zen Maru Gothic",
  // "Six Caps",
  // "Sriracha",
  // "Sofia",
  // "Ropa Sans",
  // "Volkhov",
  // "Baloo 2",
  // "Forum",
  // "Press Start 2P",
  // "Jura",
  // "Lalezar",
  // "Alex Brush",
  // "Bad Script",
  // "Noto Serif SC",
  // "Epilogue",
  // "Saira Semi Condensed",
  // "Hind Vadodara",
  // "Bai Jamjuree",
  // "Mr Dafoe",
  // "Londrina Solid",
  // "Playball",
  // "Electrolize",
  // "Fira Mono",
  // "Shippori Mincho",
  // "Reenie Beanie",
  // "Varela",
  // "Ultra",
  // "Cabin Condensed",
  // "Audiowide",
  // "Castoro",
  // "Anonymous Pro",
  // "Ruda",
  // "Nanum Pen Script",
  // "Hammersmith One",
  // "Istok Web",
  // "Neucha",
  // "Sorts Mill Goudy",
  // "Marck Script",
  // "Unica One",
  // "Lusitana",
  // "Koulen",
  // "Mada",
  // "Alef",
  // "Monda",
  // "Itim",
  // "Noto Serif Bengali",
  // "Rock Salt",
  // "League Gothic",
  // "Mandali",
  // "Niramit",
  // "Quantico",
  // "Atkinson Hyperlegible",
  // "Gilda Display",
  // "Julius Sans One",
  // "BIZ UDPGothic",
  // "Actor",
  // "Pragati Narrow",
  // "Krub",
  // "Share Tech Mono",
  // "BenchNine",
  // "Gochi Hand",
  // "Noto Sans Tamil",
  // "Cutive Mono",
  // "Sarala",
  // "Rakkas",
  // "Black Han Sans",
  // "Nothing You Could Do",
  // "Monoton",
  // "Cinzel Decorative",
  // "Fira Code",
  // "Ramabhadra",
  // "Pontano Sans",
  // "Libre Bodoni",
  // "Martel Sans",
  // "Damion",
  // "Rufina",
  // "Material Symbols Sharp",
  // "Covered By Your Grace",
  // "Playfair",
  // "Dela Gothic One",
  // "VT323",
  // "Italianno",
  // "Nova Square",
  // "Khula",
  // "Hanken Grotesk",
  // "Andika",
  // "Basic",
  // "Jaldi",
  // "Noto Sans Malayalam",
  // "Big Shoulders Display",
  // "Pinyon Script",
  // "Short Stack",
  // "Kreon",
  // "Changa One",
  // "Noto Sans Hebrew",
  // "Holtwood One SC",
  // "Economica",
  // "Quintessential",
  // "Rammetto One",
  // "Amita",
  // "Shrikhand",
  // "Trocchi",
  // "Saira Extra Condensed",
  // "Sansita",
  // "Telex",
  // "Caveat Brush",
  // "Leckerli One",
  // "Voltaire",
  // "GFS Didot",
  // "Sofia Sans Condensed",
  // "Palanquin",
  // "Newsreader",
  // "Reem Kufi",
  // "Berkshire Swash",
  // "Rozha One",
  // "Sintony",
  // "Fredoka",
  // "Calistoga",
  // "Racing Sans One",
  // "Oxanium",
  // "Laila",
  // "Days One",
  // "Averia Serif Libre",
  // "Geologica",
  // "Rubik Moonrocks",
  // "Yrsa",
  // "Rye",
  // "Calligraffitti",
  // "Karma",
  // "Alexandria",
  // "Allerta Stencil",
  // "Syncopate",
  // "Charm",
  // "Cormorant Infant",
  // "Chewy",
  // "Mrs Saint Delafield",
  // "Lemonada",
  // "Armata",
  // "Cabin Sketch",
  // "PT Serif Caption",
  // "Coda",
  // "Squada One",
  // "Petrona",
  // "Anuphan",
  // "Athiti",
  // "Arapey",
  // "Spinnaker",
  // "Balsamiq Sans",
  // "Just Another Hand",
  // "Michroma",
  // "Hind Guntur",
  // "Pathway Extreme",
  // "Sofia Sans",
  // "Zen Old Mincho",
  // "Cedarville Cursive",
  // "Mali",
  // "Alatsi",
  // "La Belle Aurore",
  // "Antic",
  // "Lustria",
  // "Aclonica",
  // "Nanum Brush Script",
  // "Glegoo",
  // "Marcellus SC",
  // "Candal",
  // "Aldrich",
  // "Shadows Into Light Two",
  // "Overpass Mono",
  // "Julee",
  // "Golos Text",
  // "Vazirmatn",
  // "Baloo Bhaijaan 2",
  // "Kiwi Maru",
  // "Fredericka the Great",
  // "Kurale",
  // "Noto Serif Display",
  // "Boogaloo",
  // "Seaweed Script",
  // "Belleza",
  // "Cantata One",
  // "Rancho",
  // "Grandstander",
  // "K2D",
  // "Galada",
  // "IBM Plex Sans Thai",
  // "Radio Canada",
  // "Wix Madefor Text",
  // "Bowlby One",
  // "Georama",
  // "BioRhyme",
  // "Alumni Sans",
  // "Herr Von Muellerhoff",
  // "Suez One",
  // "Bowlby One SC",
  // "Corben",
  // "Coming Soon",
  // "Jua",
  // "Arizonia",
  // "Encode Sans Expanded",
  // "Do Hyeon",
  // "Bevan",
  // "Caudex",
  // "Nobile",
  // "M PLUS 1",
  // "Pattaya",
  // "Delius",
  // "Graduate",
  // "Brygada 1918",
  // "Maitree",
  // "Kristi",
  // "Livvic",
  // "Allerta",
  // "Wallpoet",
  // "Ibarra Real Nova",
  // "Kameron",
  // "Sofia Sans Extra Condensed",
  // "Salsa",
  // "Klee One",
  // "Podkova",
  // "Limelight",
  // "Bellefair",
  // "Krona One",
  // "Annie Use Your Telescope",
  // "Scada",
  // "Judson",
  // "Palanquin Dark",
  // "Allison",
  // "Ephesis",
  // "Grand Hotel",
  // "Darker Grotesque",
  // "Pirata One",
  // "UnifrakturMaguntia",
  // "Arbutus Slab",
  // "Schoolbell",
  // "Oranienbaum",
  // "Averia Libre",
  // "Marmelad",
  // "Enriqueta",
  // "Proza Libre",
  // "Niconne",
  // "Alike",
  // "IBM Plex Sans KR",
  // "Stardos Stencil",
  // "Akshar",
  // "Knewave",
  // "Contrail One",
  // "Bungee Shade",
  // "Yesteryear",
  // "Manjari",
  // "Halant",
  // "David Libre",
  // "Noto Sans Kannada",
  // "Markazi Text",
  // "Alegreya SC",
  // "Average Sans",
  // "Sigmar One",
  // "Metrophobic",
  // "B612 Mono",
  // "Ovo",
  // "Encode Sans Semi Condensed",
  // "B612",
  // "Irish Grover",
  // "Henny Penny",
  // "Trirong",
  // "Overlock",
  // "Dawning of a New Day",
  // "Chonburi",
  // "Bubblegum Sans",
  // "Vollkorn SC",
  // "Shippori Mincho B1",
  // "Noto Sans Telugu",
  // "Biryani",
  // "Rochester",
  // "Lateef",
  // "Petit Formal Script",
  // "Sniglet",
  // "Kosugi",
  // "Magra",
  // "Fanwood Text",
  // "Amiko",
  // "Aladin",
  // "Nixie One",
  // "Goudy Bookletter 1911",
  // "Gurajada",
  // "Rambla",
  // "Instrument Sans",
  // "Baloo Da 2",
  // "NTR",
  // "Fahkwang",
  // "Cherry Swash",
  // "Noto Sans Gujarati",
  // "Noto Nastaliq Urdu",
  // "Zen Antique",
  // "Arya",
  // "Zen Kaku Gothic Antique",
  // "Hahmlet",
  // "Besley",
  // "Miriam Libre",
  // "Andada Pro",
  // "McLaren",
  // "Coustard",
  // "Waiting for the Sunrise",
  // "Rasa",
  // "Spectral SC",
  // "Fjord One",
  // "Mallanna",
  // "Average",
  // "Odibee Sans",
  // "Bungee Inline",
  // "Carrois Gothic",
  // "Homenaje",
  // "Grenze Gotisch",
  // "Norican",
  // "Cormorant Upright",
  // "Gabarito",
  // "Convergence",
  // "Love Ya Like A Sister",
  // "Kelly Slab",
  // "Bentham",
  // "IM Fell English SC",
  // "Big Shoulders Text",
  // "Hanuman",
  // "Montserrat Subrayada",
  // "Noto Sans Oriya",
  // "M PLUS 2",
  // "Fondamento",
  // "Gravitas One",
  // "Chivo Mono",
  // "Monsieur La Doulaise",
  // "Megrim",
  // "Qwigley",
  // "Aboreto",
  // "Italiana",
  // "IM Fell English",
  // "Thasadith",
  // "IM Fell DW Pica",
  // "Jockey One",
  // "Rosario",
  // "Poller One",
  // "Turret Road",
  // "Radley",
  // "Kdam Thmor Pro",
  // "Gloock",
  // "Oxygen Mono",
  // "Hepta Slab",
  // "Kufam",
  // "Mansalva",
  // "Schibsted Grotesk",
  // "Ma Shan Zheng",
  // "Gabriela",
  // "Fauna One",
  // "Cormorant SC",
  // "Anek Malayalam",
  // "Inknut Antiqua",
  // "Jomhuria",
  // "Vesper Libre",
  // "Style Script",
  // "Chelsea Market",
  // "Capriola",
  // "Meddon",
  // "KoHo",
  // "Copse",
  // "Skranji",
  // "Molengo",
  // "Della Respira",
  // "Tomorrow",
  // "Libre Barcode 39 Text",
  // "Baloo Paaji 2",
  // "Quando",
  // "Antic Didone",
  // "Baloo Thambi 2",
  // "Onest",
  // "Noto Sans Gurmukhi",
  // "Cambay",
  // "Oooh Baby",
  // "Caladea",
  // "Marvel",
  // "Noto Sans Lao Looped",
  // "Over the Rainbow",
  // "Patrick Hand SC",
  // "Baloo Chettan 2",
  // "Baloo Tamma 2",
  // "Noto Serif Thai",
  // "ZCOOL XiaoWei",
  // "Kaisei Decol",
  // "Sunflower",
  // "Bakbak One",
  // "Almendra",
  // "Headland One",
  // "Cambo",
  // "Ms Madi",
  // "Gayathri",
  // "Kadwa",
  // "Padauk",
  // "Glory",
  // "Germania One",
  // "Geo",
  // "Bigshot One",
  // "Angkor",
  // "DotGothic16",
  // "Federo",
  // "Nova Mono",
  // "Azeret Mono",
  // "Pompiere",
  // "REM",
  // "MuseoModerno",
  // "Share",
  // "Mr De Haviland",
  // "Zen Kurenaido",
  // "Imprima",
  // "Mouse Memoirs",
  // "Noto Serif Devanagari",
  // "Brawler",
  // "Sansita Swashed",
  // "Fresca",
  // "Noto Serif Malayalam",
  // "Cutive",
  // "Amethysta",
  // "Mochiy Pop One",
  // "Aref Ruqaa",
  // "Poly",
  // "Lexend Exa",
  // "Farro",
  // "Orelega One",
  // "Lekton",
  // "Spline Sans",
  // "Bellota Text",
  // "RocknRoll One",
  // "Anaheim",
  // "Noto Sans Sinhala",
  // "Mountains of Christmas",
  // "Gluten",
  // "Inder",
  // "Sue Ellen Francisco",
  // "IBM Plex Sans JP",
  // "Alike Angular",
  // "Sumana",
  // "Bayon",
  // "Amarante",
  // "Hurricane",
  // "Asul",
  // "BIZ UDGothic",
  // "Yusei Magic",
  // "Rouge Script",
  // "Oregano",
  // "Familjen Grotesk",
  // "Major Mono Display",
  // "Give You Glory",
  // "Croissant One",
  // "Licorice",
  "Fragment Mono",
  // "Recursive",
  // "Sedgwick Ave",
  // "Finger Paint",
  // "Encode Sans Semi Expanded",
  // "Red Rose",
  // "Oleo Script Swash Caps",
  // "Duru Sans",
  // "Mukta Vaani",
  // "Imbue",
  // "Coiny",
  // "Noto Sans Meetei Mayek",
  // "Allan",
  // "Goblin One",
  // "Bricolage Grotesque",
  // "Fuggles",
  // "Lemon",
  // "Tilt Neon",
  // "Euphoria Script",
  // "Lexend Zetta",
  // "Anek Latin",
  // "Inria Serif",
  // "Bungee Spice",
  // "Aguafina Script",
  // "Expletus Sans",
  // "Flamenco",
  // "Zen Antique Soft",
  // "Kodchasan",
  // "Gantari",
  // "Walter Turncoat",
  // "Inria Sans",
  // "Elsie",
  // "Sail",
  // "Happy Monkey",
  // "Young Serif",
  // "Montez",
  // "Vina Sans",
  // "Mako",
  // "Numans",
  // "Clicker Script",
  // "Averia Sans Libre",
  // "Suranna",
  // "Scheherazade New",
  // "Mukta Mahee",
  // "Prosto One",
  // "Carme",
  // "Hi Melody",
  // "Libre Caslon Display",
  // "Slabo 13px",
  // "Vibur",
  // "Gotu",
  // "Codystar",
  // "Noto Sans Georgian",
  // "Solway",
  // "Barriecito",
  // "Tenali Ramakrishna",
  // "Noto Sans Myanmar",
  // "Supermercado One",
  // "Just Me Again Down Here",
  // "Mogra",
  // "Syne Mono",
  // "Wix Madefor Display",
  // "ZCOOL QingKe HuangYou",
  // "Original Surfer",
  // "Crafty Girls",
  // "League Script",
  // "Noto Sans NKo Unjoined",
  // "Vast Shadow",
  // "Reem Kufi Fun",
  // "Saira Stencil One",
  // "Esteban",
  // "Dokdo",
  // "Freehand",
  // "BIZ UDPMincho",
  // "Baloo Bhai 2",
  // "Ruslan Display",
  // "Dongle",
  // "Noto Sans Symbols",
  // "Sarpanch",
  // "Artifika",
  // "Notable",
  // "Gugi",
  // "Loved by the King",
  // "Battambang",
  // "Potta One",
  // "Nerko One",
  // "Montaga",
  // "Eater",
  // "Metamorphous",
  // "Buenard",
  // "Xanh Mono",
  // "BhuTuka Expanded One",
  // "Libre Barcode 128",
  // "Goldman",
  // "Mirza",
  // "Gaegu",
  // "Delius Unicase",
  // "Puritan",
  // "The Girl Next Door",
  // "Shojumaru",
  // "Wendy One",
  // "Monomaniac One",
  // "Spicy Rice",
  // "Slackey",
  // "Manuale",
  // "Charmonman",
  // "Noto Sans Armenian",
  // "Mochiy Pop P One",
  // "Nokora",
  // "Atma",
  // "Shalimar",
  // "Ceviche One",
  // "Overlock SC",
  // "Kranky",
  // "Kaisei Tokumin",
  // "Libre Barcode 39 Extended Text",
  // "Corinthia",
  // "Birthstone",
  // "Chau Philomene One",
  // "Bilbo Swash Caps",
  // "Ramaraja",
  // "Harmattan",
  // "Dynalight",
  // "Bellota",
  // "Nova Round",
  // "Sulphur Point",
  // "Trykker",
  // "Tiro Kannada",
  // "Edu SA Beginner",
  // "Wire One",
  // "Unkempt",
  // "Kaisei Opti",
  // "Rampart One",
  // "Cherry Cream Soda",
  // "Martian Mono",
  // "Lily Script One",
  // "Share Tech",
  // "Modak",
  // "Scope One",
  // "Tienne",
  // "Abyssinica SIL",
  // "Balthazar",
  // "Trade Winds",
  // "Tauri",
  // "Faster One",
  // "Red Hat Mono",
  // "Freckle Face",
  // "IM Fell Double Pica",
  // "Fontdiner Swanky",
  // "Sofia Sans Semi Condensed",
  // "Noto Serif HK",
  // "Timmana",
  // "Life Savers",
  // "Noto Serif Hebrew",
  // "Hina Mincho",
  // "Doppio One",
  // "Stick",
  // "Baumans",
  // "MedievalSharp",
  // "Ledger",
  // "Protest Revolution",
  // "Road Rage",
  // "Medula One",
  // "Peralta",
  // "Shanti",
  // "Shantell Sans",
  // "Ruthie",
  // "Emilys Candy",
  // "Tiro Bangla",
  // "Viaoda Libre",
  // "Kalnia",
  // "Orienta",
  // "Caprasimo",
  // "Reddit Mono",
  // "Reggae One",
  // "Noto Serif Georgian",
  // "Redressed",
  // "Instrument Serif",
  // "Voces",
  // "Montagu Slab",
  // "Noto Emoji",
  // "Cormorant Unicase",
  // "Belgrano",
  // "ADLaM Display",
  // "Qwitcher Grypen",
  // "Mina",
  // "Monofett",
  // "Ranchers",
  // "Bubbler One",
  // "Grape Nuts",
  // "Gowun Dodum",
  // "Sura",
  // "Poltawski Nowy",
  // "Stint Ultra Condensed",
  // "Gemunu Libre",
  // "Chango",
  // "Rhodium Libre",
  // "Baloo Bhaina 2",
  // "Rubik Doodle Shadow",
  // "Zen Dots",
  // "ZCOOL KuaiLe",
  // "Katibeh",
  // "Gamja Flower",
  // "Rubik Dirt",
  // "Lexend Peta",
  // "Jomolhari",
  // "Londrina Outline",
  // "Song Myung",
  // "Varta",
  // "Pixelify Sans",
  // "Murecho",
  // "Tilt Warp",
  // "Comforter Brush",
  // "Pavanam",
  // "Delius Swash Caps",
  // "IM Fell French Canon",
  // "Metal Mania",
  // "Crushed",
  // "Frijole",
  // "Square Peg",
  // "Victor Mono",
  // "East Sea Dokdo",
  // "Modern Antiqua",
  // "Rosarivo",
  // "Prociono",
  // "Asar",
  // "Lovers Quarrel",
  // "Alkatra",
  // "Zilla Slab Highlight",
  // "Akronim",
  // "Alkalami",
  // "Tillana",
  // "Iceland",
  // "Miniver",
  // "Hachi Maru Pop",
  // "Raleway Dots",
  // "Swanky and Moo Moo",
  // "Libre Barcode 128 Text",
  // "Single Day",
  // "Lexend Mega",
  // "Gowun Batang",
  // "Bona Nova",
  // "Sonsie One",
  // "Butterfly Kids",
  // "Yarndings 12",
  // "Port Lligat Sans",
  // "Yarndings 20 Charted",
  // "Rubik Scribble",
  // "Gafata",
  // "Yarndings 12 Charted",
  // "Yarndings 20",
  // "Strait",
  // "WindSong",
  // "Rum Raisin",
  // "Agbalumo",
  // "Noto Sans Khmer",
  // "Iceberg",
  // "Denk One",
  // "Anybody",
  // "Moul",
  // "Ribeye",
  // "Akaya Telivigala",
  // "Yuji Syuku",
  // "Noto Serif Telugu",
  // "Kantumruy Pro",
  // "MonteCarlo",
  // "Gorditas",
  // "Sunshiney",
  // "Carlito",
  // "Arima",
  // "Suwannaphum",
  // "Stalemate",
  // "Meow Script",
  // "Karantina",
  // "Fenix",
  // "Galdeano",
  // "Carrois Gothic SC",
  // "Noto Sans Adlam",
  // "Workbench",
  // "Macondo Swash Caps",
  // "Nova Flat",
  // "Stylish",
  // "Marhey",
  // "Barrio",
  // "Maiden Orange",
  // "IM Fell Great Primer",
  // "Anek Bangla",
  // "Nosifer",
  // "Fuzzy Bubbles",
  // "Engagement",
  // "IM Fell DW Pica SC",
  // "Cute Font",
  // "Habibi",
  // "M PLUS 1 Code",
  // "Bahianita",
  // "UnifrakturCook",
  // "Yomogi",
  // "Uncial Antiqua",
  // "Rationale",
  // "Shippori Antique",
  // "Kulim Park",
  // "Afacad",
  // "Cantora One",
  // "Anek Devanagari",
  // "Flow Circular",
  // "Tiro Devanagari Hindi",
  // "Madimi One",
  // "Meera Inimai",
  // "Kite One",
  // "Farsan",
  // "Sree Krushnadevaraya",
  // "Lexend Giga",
  // "Asset",
  // "Dekko",
  // "Meie Script",
  // "Noto Sans Lao",
  // "Paprika",
  // "Smooch Sans",
  // "Vujahday Script",
  // "Sancreek",
  // "Tac One",
  // "Whisper",
  // "Noto Sans Anatolian Hieroglyphs",
  // "Milonga",
  // "IBM Plex Sans Hebrew",
  // "Baloo Tammudu 2",
  // "Mystery Quest",
  // "Genos",
  // "Bruno Ace SC",
  // "Port Lligat Slab",
  // "Jolly Lodger",
  // "Tektur",
  // "Smythe",
  // "Finlandica",
  // "Anta",
  // "Kaisei HarunoUmi",
  // "IM Fell French Canon SC",
  // "Fasthand",
  // "Sedgwick Ave Display",
  // "Waterfall",
  // "Delicious Handrawn",
  // "Srisakdi",
  // "Offside",
  // "Kotta One",
  // "Akaya Kanadaka",
  // "Nova Slim",
  // "Kenia",
  // "Margarine",
  // "Redacted",
  // "Moon Dance",
  // "Caesar Dressing",
  // "Beth Ellen",
  // "Donegal One",
  // "IM Fell Great Primer SC",
  // "Underdog",
  // "Stoke",
  // "Bungee Hairline",
  // "Passions Conflict",
  // "Spline Sans Mono",
  // "Astloch",
  // "Stick No Bills",
  // "Arbutus",
  // "Mohave",
  // "Ysabeau Office",
  // "Eagle Lake",
  // "IM Fell Double Pica SC",
  // "Charis SIL",
  // "Text Me One",
  // "Piazzolla",
  // "Shippori Antique B1",
  // "Black And White Picture",
  // "Carattere",
  // "Poor Story",
  // "Girassol",
  // "Khmer",
  // "Miltonian Tattoo",
  // "The Nautigal",
  // "Molle",
  // "Nova Cut",
  // "Anek Tamil",
  // "Junge",
  // "Keania One",
  // "Sarina",
  // "Nova Script",
  // "Cagliostro",
  // "Birthstone Bounce",
  // "Nova Oval",
  // "Tilt Prism",
  // "Dorsa",
  // "AR One Sans",
  // "Miltonian",
  // "Zhi Mang Xing",
  // "Stint Ultra Expanded",
  // "Inika",
  // "Chilanka",
  // "Bilbo",
  // "Kumar One",
  // "Felipa",
  // "Marko One",
  // "Kavoon",
  // "Mrs Sheppards",
  // "Sahitya",
  // "Trispace",
  // "Chicle",
  // "New Rocker",
  // "Condiment",
  // "Noto Sans Thai Looped",
  // "Long Cang",
  // "Wellfleet",
  // "Noto Sans Math",
  // "Smooch",
  // "Aoboshi One",
  // "Akatab",
  // "Beau Rivage",
  // "Averia Gruesa Libre",
  // "Comforter",
  // "Unlock",
  // "Train One",
  // "Kavivanar",
  // "Simonetta",
  // "Linden Hill",
  // "Buda",
  // "Liu Jian Mao Cao",
  // "IBM Plex Sans Thai Looped",
  // "Spirax",
  // "Fascinate",
  // "Ruluko",
  // "Vampiro One",
  // "Gentium Plus",
  // "Seymour One",
  // "BIZ UDMincho",
  // "New Tegomin",
  // "Tulpen One",
  // "Jacques Francois",
  // "Englebert",
  // "Noto Sans Gothic",
  // "Kirang Haerang",
  // "Qahiri",
  // "Edu NSW ACT Foundation",
  // "Texturina",
  // "Belanosima",
  // "Rethink Sans",
  // "Playpen Sans",
  // "Chathura",
  // "Noto Sans Buhid",
  // "Ravi Prakash",
  // "Autour One",
  // "Libre Barcode 39 Extended",
  // "Benne",
  // "Galindo",
  // "Yeon Sung",
  // "Odor Mean Chey",
  // "Gentium Book Plus",
  // "Imperial Script",
  // "Kumar One Outline",
  // "Anek Telugu",
  // "Noto Sans Symbols 2",
  // "Elsie Swash Caps",
  // "Koh Santepheap",
  // "Joti One",
  // "Content",
  // "Climate Crisis",
  // "Oldenburg",
  // "Sirin Stencil",
  // "Gulzar",
  // "Yaldevi",
  // "Risque",
  // "Protest Riot",
  // "Preahvihear",
  // "Plaster",
  // "Romanesco",
  // "Amiri Quran",
  // "Atomic Age",
  // "Glass Antiqua",
  // "Sono",
  // "Hanalei Fill",
  // "Grenze",
  // "Ranga",
  // "Luxurious Script",
  // "Water Brush",
  // "Londrina Shadow",
  // "Gupter",
  // "Bahiana",
  // "DynaPuff",
  // "Alumni Sans Inline One",
  // "Ewert",
  // "Braah One",
  // "Smokum",
  // "Princess Sofia",
  // "Almendra SC",
  // "Anek Gujarati",
  // "Piedra",
  // "Big Shoulders Stencil Text",
  // "Ribeye Marrow",
  // "Ysabeau",
  // "Dangrek",
  // "Lakki Reddy",
  // "Dr Sugiyama",
  // "Truculenta",
  // "Zen Tokyo Zoo",
  // "Gwendolyn",
  // "Lancelot",
  // "Phudu",
  // "Bonheur Royale",
  // "Bungee Outline",
  // "Tiro Devanagari Marathi",
  // "Griffy",
  // "Jacques Francois Shadow",
  // "Festive",
  // "Noto Serif Khojki",
  // "Labrada",
  // "Anek Gurmukhi",
  // "Hubballi",
  // "Diplomata SC",
  // "Noto Sans Ethiopic",
  // "Praise",
  // "Borel",
  // "Noto Sans Samaritan",
  // "Encode Sans SC",
  // "BioRhyme Expanded",
  // "Anek Kannada",
  // "Snippet",
  // "Emblema One",
  // "Solitreo",
  // "Darumadrop One",
  // "Lacquer",
  // "Fascinate Inline",
  // "Kode Mono",
  // "Revalia",
  // "Flavors",
  // "Lexend Tera",
  // "Chela One",
  // "Noto Serif Kannada",
  // "Erica One",
  // "Sometype Mono",
  // "Almendra Display",
  // "Bagel Fat One",
  // "Bokor",
  // "Bigelow Rules",
  // "Agdasima",
  // "Mea Culpa",
  // "Protest Strike",
  // "Konkhmer Sleokchher",
  // "IBM Plex Sans Devanagari",
  // "GFS Neohellenic",
  // "Big Shoulders Stencil Display",
  // "Devonshire",
  // "Tiro Devanagari Sanskrit",
  // "Big Shoulders Inline Text",
  // "Peddana",
  // "Joan",
  // "Cairo Play",
  // "Mr Bedfort",
  // "Federant",
  // "Foldit",
  // "Lavishly Yours",
  // "Siemreap",
  // "Babylonica",
  // "Rubik Distressed",
  // "Gasoek One",
  // "Jim Nightshade",
  // "Trochut",
  // "Caramel",
  // "Blaka",
  // "Ysabeau Infant",
  // "Stalinist One",
  // "Butcherman",
  // "Neonderthaw",
  // "Rubik Glitch",
  // "Noto Sans Sharada",
  // "Edu TAS Beginner",
  // "Metal",
  // "Dhurjati",
  // "Passero One",
  // "Diplomata",
  // "Gidugu",
  // "Miss Fajardose",
  // "Noto Serif Sinhala",
  // "Londrina Sketch",
  // "Lumanosimo",
  // "Sevillana",
  // "Rubik Iso",
  // "Libre Barcode EAN13 Text",
  // "Noto Sans Tai Viet",
  // "Inclusive Sans",
  // "Ballet",
  // "Noto Sans Old South Arabian",
  // "Chenla",
  // "Aubrey",
  // "Anek Odia",
  // "Love Light",
  // "Noto Serif Armenian",
  // "Gideon Roman",
  // "Geostar",
  // "Vibes",
  // "Combo",
  // "Uchen",
  // "Inspiration",
  // "My Soul",
  // "Reem Kufi Ink",
  // "Alumni Sans Collegiate One",
  // "Noto Serif Vithkuqi",
  // "Noto Serif Khmer",
  // "Taprom",
  // "Rubik Wet Paint",
  // "Bacasime Antique",
  // "Updock",
  // "Luxurious Roman",
  // "Castoro Titling",
  // "Tiro Telugu",
  // "Aref Ruqaa Ink",
  // "Mynerve",
  // "Sofadi One",
  // "Fruktur",
  // "Redacted Script",
  // "Ruge Boogie",
  // "Suravaram",
  // "Mooli",
  // "Honk",
  // "Yuji Mai",
  // "Explora",
  // "Ojuju",
  // "Flow Block",
  // "Cherry Bomb One",
  // "Yuji Boku",
  // "Noto Serif Gujarati",
  // "Tiro Tamil",
  // "Rubik Beastly",
  // "Langar",
  // "Handjet",
  // "Fleur De Leah",
  // "Hedvig Letters Serif",
  // "Moulpali",
  // "Nabla",
  // "Ysabeau SC",
  // "Tourney",
  // "Purple Purse",
  // "Noto Sans Osmanya",
  // "Hedvig Letters Sans",
  // "Island Moments",
  // "Snowburst One",
  // "Tsukimi Rounded",
  // "Nuosu SIL",
  // "Splash",
  // "Tai Heritage Pro",
  // "Oi",
  // "Send Flowers",
  // "Bonbon",
  // "Bruno Ace",
  // "Comme",
  // "Alumni Sans Pinstripe",
  // "Noto Sans Javanese",
  // "Diphylleia",
  // "Edu VIC WA NT Beginner",
  // "Noto Serif Ethiopic",
  // "Kolker Brush",
  // "Sassy Frass",
  // "Noto Rashi Hebrew",
  // "Geostar Fill",
  // "Rubik Vinyl",
  // "Sixtyfour",
  // "Noto Sans Syloti Nagri",
  // "Big Shoulders Inline Display",
  // "Noto Serif Balinese",
  // "Moirai One",
  // "Grechen Fuemen",
  // "Zen Loop",
  // "Noto Serif Tibetan",
  // "Dai Banna SIL",
  // "Noto Sans Sora Sompeng",
  // "Noto Sans Lepcha",
  // "Noto Sans Tagalog",
  // "Gajraj One",
  // "Petemoss",
  // "Protest Guerrilla",
  // "Palette Mosaic",
  // "Rubik Doodle Triangles",
  // "Sigmar",
  // "Kablammo",
  // "Noto Music",
  // "Micro 5",
  // "Noto Sans Mongolian",
  // "Slackside One",
  // "Rubik 80s Fade",
  // "Noto Serif Tangut",
  // "Annapurna SIL",
  // "Noto Sans Coptic",
  // "Cherish",
  // "Noto Serif NP Hmong",
  // "Estonia",
  // "Are You Serious",
  // "Grey Qo",
  // "Jacquarda Bastarda 9",
  // "Noto Sans Canadian Aboriginal",
  // "Edu QLD Beginner",
  // "Tiro Gurmukhi",
  // "Noto Serif Lao",
  // "Noto Sans Tangsa",
  // "Ruwudu",
  // "Noto Serif Toto",
  // "Noto Serif Tamil",
  // "Orbit",
  // "Syne Tactile",
  // "Moo Lah Lah",
  // "Namdhinggo",
  // "Noto Sans Old Hungarian",
  // "Lugrasimo",
  // "Noto Sans Glagolitic",
  // "Flow Rounded",
  // "Warnes",
  // "Noto Sans Batak",
  // "Grandiflora One",
  // "M PLUS Code Latin",
  // "Noto Serif Ottoman Siyaq",
  // "Rubik Glitch Pop",
  // "Twinkle Star",
  // "Rubik Spray Paint",
  // "Tapestry",
  // "Hanalei",
  // "Noto Traditional Nushu",
  // "Noto Sans Carian",
  // "Noto Sans Miao",
  // "Noto Sans Linear A",
  // "Rubik Puddles",
  // "Noto Sans Imperial Aramaic",
  // "Noto Sans Thaana",
  // "Ingrid Darling",
  // "Rubik Pixels",
  // "Ole",
  // "Noto Sans Old Italic",
  // "Rubik Gemstones",
  // "Rubik Microbe",
  // "Lunasima",
  // "Noto Serif Yezidi",
  // "Rubik Burned",
  // "Rubik Maze",
  // "Rock 3D",
  // "Noto Sans Egyptian Hieroglyphs",
  // "Shizuru",
  // "Blaka Hollow",
  // "Noto Serif Myanmar",
  // "Noto Sans Cypro Minoan",
  // "Blaka Ink",
  // "Rubik Maps",
  // "Yuji Hentaigana Akari",
  // "Lisu Bosa",
  // "Noto Serif Ahom",
  // "Kings",
  // "Rubik Marker Hatch",
  // "Rubik Storm",
  // "Noto Sans Balinese",
  // "Puppies Play",
  // "Noto Sans Cherokee",
  // "Noto Sans Nag Mundari",
  // "Rubik Broken Fax",
  // "Noto Sans Avestan",
  // "Linefont",
  // "Noto Sans Bamum",
  // "Noto Sans Adlam Unjoined",
  // "Noto Sans Khojki",
  // "Noto Sans Kawi",
  // "Noto Sans Deseret",
  // "Noto Sans Ol Chiki",
  // "Noto Sans Hanunoo",
  // "Noto Sans Nandinagari",
  // "Noto Serif Oriya",
  // "Noto Sans Bassa Vah",
  // "Noto Sans Medefaidrin",
  // "Noto Sans Chakma",
  // "Noto Sans Lydian",
  // "Noto Sans Tifinagh",
  // "Noto Sans Marchen",
  // "Kay Pho Du",
  // "Noto Sans Old Persian",
  // "Noto Sans Cham",
  // "Noto Sans Kaithi",
  // "Padyakke Expanded One",
  // "Noto Serif Grantha",
  // "Noto Sans Indic Siyaq Numbers",
  // "Noto Serif Makasar",
  // "Noto Sans Takri",
  // "Rubik Lines",
  // "Noto Sans Tamil Supplement",
  // "Noto Sans Chorasmian",
  // "Noto Sans Yi",
  // "Noto Sans Brahmi",
  // "Mingzat",
  // "Noto Sans Zanabazar Square",
  // "Noto Sans Inscriptional Pahlavi",
  // "Noto Sans Vithkuqi",
  // "Noto Sans Kayah Li",
  // "Noto Sans Vai",
  // "Noto Sans Sundanese",
  // "Noto Sans Lycian",
  // "Noto Sans Lisu",
  // "Noto Serif Dogra",
  // "Noto Sans Old Turkic",
  // "Noto Sans Tagbanwa",
  // "Noto Sans Multani",
  // "Wavefont",
  // "Noto Serif Old Uyghur",
  // "Noto Serif Gurmukhi",
  // "Yuji Hentaigana Akebono",
  // "Noto Sans Tai Tham",
  // "Noto Sans Wancho",
  // "Narnoor",
  // "Noto Sans Cypriot",
  // "Noto Sans Siddham",
  // "Noto Serif Khitan Small Script",
  // "Noto Sans Shavian",
  // "Noto Sans Limbu",
  // "Noto Sans Phags Pa",
  // "Noto Sans Pahawh Hmong",
  // "Noto Sans Inscriptional Parthian",
  // "Noto Sans Syriac",
  // "Noto Sans Tai Le",
  // "Noto Sans Psalter Pahlavi",
  // "Noto Sans Palmyrene",
  // "Noto Sans Duployan",
  // "Noto Sans Syriac Eastern",
  // "Noto Sans Old North Arabian",
  // "Noto Sans Khudawadi",
  // "Noto Sans Cuneiform",
  // "Noto Sans Old Permic",
  // "Noto Sans Tirhuta",
  // "Noto Sans Grantha",
  // "Noto Sans Saurashtra",
  // "Noto Sans Osage",
  // "Noto Sans Runic",
  // "Noto Sans Newa",
  // "Noto Sans Buginese",
  // "Noto Sans Mayan Numerals",
  // "Noto Sans Mandaic",
  // "Chokokutai",
  // "Noto Sans Hanifi Rohingya",
  // "Noto Sans Nabataean",
  // "Noto Sans Phoenician",
  // "Noto Sans Rejang",
  // "Noto Sans Hatran",
  // "Noto Sans Gunjala Gondi",
  // "Noto Sans Bhaiksuki",
  // "Noto Sans Linear B",
  // "Noto Sans Sogdian",
  // "Noto Sans Caucasian Albanian",
  // "Noto Sans Mro",
  // "Noto Sans New Tai Lue",
  // "Noto Sans Modi",
  // "Noto Sans Old Sogdian",
  // "Noto Sans Ogham",
  // "Noto Sans Ugaritic",
  // "Noto Sans Kharoshthi",
  // "Noto Sans Elymaic",
  // "Noto Sans Warang Citi",
  // "Noto Sans Masaram Gondi",
  // "Noto Sans Meroitic",
  // "Noto Sans Mende Kikakui",
  // "Noto Sans Nushu",
  // "Noto Sans Soyombo",
  // "Noto Sans Elbasan",
  // "Noto Sans Manichaean",
  // "Noto Sans Mahajani",
  // "Noto Sans Pau Cin Hau",
  // "Noto Sans SignWriting",
  // "Noto Sans NKo"
];
